import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-budget-reward-tabs',
  templateUrl: './budget-reward-tabs.component.html',
  styleUrls: ['./budget-reward-tabs.component.css']
})
export class BudgetRewardTabsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
